if (!customElements.get("okendo-attribute-rating")) {
  class OkendoAttributeRating extends HTMLElement {
    constructor() {
      super();
    }

    selectors = {
      label: {
        min: "[data-attribute-rating-widget-label-min]",
        mid: "[data-attribute-rating-widget-label-mid]",
        max: "[data-attribute-rating-widget-label-max]"
      },
      value: "[data-attribute-rating-widget-value]",
      instructions: "[data-attribute-rating-instructions]",
      message: "[data-attribute-rating-qualifying-message]"
    };

    modifiers = {
      hidden: "hidden"
    };

    attributes = {
      productId: "product-id"
    };

    get productId() {
      return this.getAttribute(this.attributes.productId);
    }

    get okendoUserId() {
      return theme.okendo_user_id;
    }

    get okendoAttributeRatingType() {
      return "centered-range";
    }

    async connectedCallback() {
      const url = `https://api.okendo.io/v1/stores/${this.okendoUserId}/products/shopify-${this.productId}/review_aggregate`;

      const response = await fetch(url);
      const data = await response.json();

      const { reviewAggregate } = data;
      const { attributeRatings } = reviewAggregate || {};

      if (!attributeRatings || !attributeRatings.length) {
        return;
      }

      const [attributeRating] = attributeRatings;
      const { type, value, minLabel, midLabel, maxLabel } = attributeRating;

      if (type !== this.okendoAttributeRatingType) {
        return;
      }

      this.buildWidget(value, minLabel, midLabel, maxLabel);

      this.classList.remove(this.modifiers.hidden);
    }

    buildWidget(value, minLabel, midLabel, maxLabel) {
      const labelMinElement = this.querySelector(this.selectors.label.min);
      const labelMidElement = this.querySelector(this.selectors.label.mid);
      const labelMaxElement = this.querySelector(this.selectors.label.max);

      if (labelMinElement) {
        labelMinElement.innerText = minLabel;
      }

      if (labelMidElement) {
        labelMidElement.innerText = midLabel;
      }

      if (labelMaxElement) {
        labelMaxElement.innerText = maxLabel;
      }

      const valueElement = this.querySelector(this.selectors.value);

      if (valueElement) {
        valueElement.style.left = `calc(50% + ${(value / 2 * 100)}%)`;
      }

      const instructionsElement = this.querySelector(this.selectors.instructions);

      if (instructionsElement) {
        instructionsElement.innerHTML = this.getContent("instructions", value);
      }

      const messageElement = this.querySelector(this.selectors.message);

      if (messageElement) {
        messageElement.innerHTML = this.getContent("message", value);
      }
    }

    getContent(type, value) {
      const roundedValue = Math.round(value * 100) / 100;

      if (roundedValue >= 0 && roundedValue <= 0.09) {
        return type === "message" ? theme.strings.sizing.messaging.true_to_size : theme.strings.sizing.true_to_size;
      } else if (roundedValue >= 0.10 && roundedValue <= 0.49) {
        return type === "message" ? theme.strings.sizing.messaging.runs_slightly_large : theme.strings.sizing.runs_slightly_large;
      } else if (roundedValue >= 0.5 && roundedValue <= 1) {
        return type === "message" ? theme.strings.sizing.messaging.runs_large : theme.strings.sizing.runs_large;
      } else if (roundedValue >= -0.09 && roundedValue <= 0) {
        return type === "message" ? theme.strings.sizing.messaging.true_to_size : theme.strings.sizing.true_to_size;
      } else if (roundedValue >= -0.49 && roundedValue <= -0.10) {
        return type === "message" ? theme.strings.sizing.messaging.runs_slightly_small : theme.strings.sizing.runs_slightly_small;
      } else if (roundedValue >= -1 && roundedValue <= -0.5) {
        return type === "message" ? theme.strings.sizing.messaging.runs_small : theme.strings.sizing.runs_small;
      } else {
        return "";
      }
    }
  }

  customElements.define("okendo-attribute-rating", OkendoAttributeRating);
}
